/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_Grower_FacesInputs */

const vi_api_keys_perm_grower_faces = /** @type {(inputs: Api_Keys_Perm_Grower_FacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khuôn mặt hộ trồng`)
};

/**

* @param {Api_Keys_Perm_Grower_FacesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_grower_faces = /** @type {((inputs?: Api_Keys_Perm_Grower_FacesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_Grower_FacesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_grower_faces(inputs)
});